export default __webpack_public_path__ + "static/media/Julia.b287ac6a.jpg";